// extracted by mini-css-extract-plugin
export default {"infoSection":"byVDjequ","infoItem":"C4yGKJkS","label":"prrAshDo","value":"zJ4G8HW7","textBox":"l1Y8Zwt2"};